import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';

export default function AdminDashboard() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    try { await api.post('/auth/logout'); } catch(e) {}
    logout(); navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🛡️</span>
          <div>
            <h1 className="font-bold text-lg">SantéTogo Admin</h1>
            <p className="text-xs text-gray-400">Panneau d'administration</p>
          </div>
        </div>
        <button onClick={handleLogout} className="text-sm text-red-400 hover:text-red-300">
          Déconnexion
        </button>
      </div>

      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <h2 className="text-xl font-bold">Tableau de bord</h2>

        {/* Stats */}
        {stats && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              {label:'Patients', value: stats.total_patients, icon:'👥', color:'bg-blue-600'},
              {label:'Médecins', value: stats.total_doctors, icon:'👨‍⚕️', color:'bg-green-600'},
              {label:'RDV Total', value: stats.total_appointments, icon:'📅', color:'bg-purple-600'},
              {label:'Revenus', value: parseInt(stats.total_revenue||0).toLocaleString()+' F', icon:'💰', color:'bg-yellow-600'},
            ].map(s => (
              <div key={s.label} className={`${s.color} rounded-2xl p-4 text-center`}>
                <div className="text-3xl mb-1">{s.icon}</div>
                <div className="font-bold text-xl">{s.value}</div>
                <div className="text-xs opacity-80">{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Navigation */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {[
            {to:'/admin/doctors', icon:'👨‍⚕️', label:'Gérer les médecins', desc:'Validation, vérification'},
            {to:'/admin/patients', icon:'👥', label:'Gérer les patients', desc:'Liste, blocage'},
            {to:'/admin/appointments', icon:'📅', label:'Rendez-vous', desc:'Tous les RDV'},
            {to:'/admin/payments', icon:'💰', label:'Paiements', desc:'Transactions'},
            {to:'/admin/specialties', icon:'🏥', label:'Spécialités', desc:'Gérer les spécialités'},
            {to:'/admin/users', icon:'⚙️', label:'Utilisateurs', desc:'Gestion comptes'},
          ].map(item => (
            <Link key={item.to} to={item.to}
              className="bg-gray-800 border border-gray-700 rounded-2xl p-4 hover:border-green-500 transition-all">
              <div className="text-3xl mb-2">{item.icon}</div>
              <p className="font-semibold text-sm">{item.label}</p>
              <p className="text-xs text-gray-400 mt-0.5">{item.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
